import { DateTime } from 'luxon';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { featuresApi } from './featuresAPI';

export interface FeaturesState {
  currentDate: string;
}

const initialState: FeaturesState = {
  currentDate: '',
};

export const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(featuresApi.endpoints.getSystemDate.matchFulfilled, (state, action) => {
      state.currentDate = action.payload;
    });
    builder.addMatcher(featuresApi.endpoints.setDate.matchFulfilled, (state, action) => {
      state.currentDate = action.payload;
    });
    builder.addMatcher(featuresApi.endpoints.resetDate.matchFulfilled, (state, action) => {
      state.currentDate = action.payload;
    });
  },
});

export const selectSystemDate = (state: RootState) =>
  state.features.currentDate ? DateTime.fromISO(state.features.currentDate).toFormat('dd/MM/yyyy') : '';

export const selectSystemDateTime = (state: RootState) =>
  state.features.currentDate
    ? DateTime.fromISO(state.features.currentDate).toJSDate().getTime()
    : DateTime.now().toJSDate().getTime();

export default featuresSlice.reducer;
